"use client"

import type React from "react"
import { Container, Row, Col } from "reactstrap"
import ExhibitorStatsCard from "./stats-card" // Corrected import path
import RepresentativesAttendance from "./representatives-attendance" // Corrected import path
import VehicleAttendance from "./vehicle-attendance" // Corrected import path
import { ToastContainer } from "react-toastify"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import "react-toastify/dist/ReactToastify.css" // Import Toastify CSS

const ExhibitorReportsContainer: React.FC = () => {
  return (
    <>
      {/* <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}

      <Container fluid={true}>
        
        <ExhibitorStatsCard />

        <hr className="my-4" />

        <Row className="mb-4">
          <Col>
            <h3 className="text-dark mb-3">
              <i className="fa fa-users me-2"></i>
              Representative Attendance
            </h3>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <RepresentativesAttendance />
          </Col>
        </Row>

        <hr className="my-4" />

        <Row className="mb-4">
          <Col>
            <h3 className="text-dark mb-3">
              <i className="fa fa-car me-2"></i>
              Vehicle Attendance
            </h3>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <VehicleAttendance />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default ExhibitorReportsContainer
